import { gql } from '@apollo/client';

// ── Locais ──────────────────────────────────────────────────────────────────

export const LISTAR_LOCAIS = gql`
  query ListarLocais {
    locais {
      id
      nome
      descricao
      endereco {
        logradouro
        numero
        bairro
        cep
        cidade { id nome }
      }
    }
  }
`;

export const MEUS_LOCAIS = gql`
  query MeusLocais {
    meusLocais {
      id
      nome
      descricao
      urlLocalizacao
      aluguelHabilitado
      aceitaPix
      aceitaCartao
      janelaHorasReembolso
      percentualDescontoAluno
      ligaRecebedora { id nome }
      endereco {
        id
        logradouro
        numero
        bairro
        cep
        complemento
        cidade { id nome uf }
      }
      organizadores {
        id
        usuario { id nome email }
        criadoEm
      }
    }
  }
`;

export const ORGANIZADORES_LOCAL = gql`
  query AdministradoresLocal($localId: ID!) {
    organizadoresLocal(localId: $localId) {
      id
      usuario { id nome email }
      criadoEm
    }
  }
`;

export const ADICIONAR_ORGANIZADOR_LOCAL = gql`
  mutation AdicionarAdminLocal($localId: ID!, $usuarioId: ID!) {
    adicionarOrganizadorLocal(localId: $localId, usuarioId: $usuarioId) {
      id
      usuario { id nome email }
      criadoEm
    }
  }
`;

export const REMOVER_ORGANIZADOR_LOCAL = gql`
  mutation RemoverAdminLocal($localId: ID!, $usuarioId: ID!) {
    removerOrganizadorLocal(localId: $localId, usuarioId: $usuarioId)
  }
`;

export const LISTAR_CIDADES_GQL = gql`
  query ListarCidades {
    cidades { id nome uf }
  }
`;

export const CRIAR_LOCAL = gql`
  mutation CriarLocal($input: LocalInput!) {
    criarLocal(input: $input) {
      id nome descricao aluguelHabilitado
      ligaRecebedora { id nome }
      endereco { id logradouro numero bairro cep cidade { id nome uf } }
    }
  }
`;

export const ATUALIZAR_LOCAL = gql`
  mutation AtualizarLocal($id: ID!, $input: LocalInput!) {
    atualizarLocal(id: $id, input: $input) {
      id nome descricao aluguelHabilitado aceitaPix aceitaCartao
      ligaRecebedora { id nome }
      endereco { id logradouro numero bairro cep cidade { id nome uf } }
    }
  }
`;

export const TOGGLE_ALUGUEL_LOCAL = gql`
  mutation ToggleAluguelLocal($id: ID!, $aluguelHabilitado: Boolean!) {
    toggleAluguelLocal(id: $id, aluguelHabilitado: $aluguelHabilitado) {
      id
      aluguelHabilitado
    }
  }
`;

export const DELETAR_LOCAL = gql`
  mutation DeletarLocal($id: ID!) {
    deletarLocal(id: $id)
  }
`;

// ── Quadras ──────────────────────────────────────────────────────────────────

export const QUADRAS_POR_LOCAL = gql`
  query QuadrasPorLocal($localId: ID!) {
    quadrasPorLocal(localId: $localId) {
      id
      nome
      descricao
      tipoPiso
      observacao
      imagens { id url ordem }
      ativa
      duracaoSlotMinutos
    }
  }
`;

export const QUADRAS_POR_LOCAL_ADMIN = gql`
  query QuadrasPorLocalAdmin($localId: ID!) {
    quadrasPorLocalAdmin(localId: $localId) {
      id
      nome
      descricao
      tipoPiso
      observacao
      imagens { id url ordem }
      ativa
      duracaoSlotMinutos
      pendenciasConfiguracao {
        semHorarios
        semPrecos
        horariosDescobertosSemPreco
      }
    }
  }
`;

export const QUADRA_ADMIN = gql`
  query QuadraAdmin($id: ID!) {
    quadraPorId(id: $id) {
      id
      nome
      descricao
      tipoPiso
      observacao
      imagens { id url ordem }
      ativa
      duracaoSlotMinutos
      local { id }
    }
  }
`;

export const CRIAR_QUADRA = gql`
  mutation CriarQuadra($input: QuadraInput!) {
    criarQuadra(input: $input) { id nome }
  }
`;

export const ATUALIZAR_QUADRA = gql`
  mutation AtualizarQuadra($id: ID!, $input: QuadraInput!) {
    atualizarQuadra(id: $id, input: $input) { id nome }
  }
`;

export const DELETAR_QUADRA = gql`
  mutation DeletarQuadra($id: ID!) {
    deletarQuadra(id: $id)
  }
`;

export const UPLOAD_IMAGEM_QUADRA = gql`
  mutation UploadImagemQuadra($quadraId: ID!, $arquivo: Upload!) {
    uploadImagemQuadra(quadraId: $quadraId, arquivo: $arquivo) {
      id
      imagens { id url ordem }
    }
  }
`;

// ── Horários Permitidos ───────────────────────────────────────────────────────

export const HORARIOS_PERMITIDOS = gql`
  query HorariosPermitidos($quadraId: ID!) {
    horariosPermitidos(quadraId: $quadraId) {
      id
      diaSemana
      horaInicio
      horaFim
    }
  }
`;

export const CRIAR_HORARIO_PERMITIDO = gql`
  mutation CriarHorarioPermitido($quadraId: ID!, $input: HorarioPermitidoInput!) {
    criarHorarioPermitido(quadraId: $quadraId, input: $input) {
      id diaSemana horaInicio horaFim
    }
  }
`;

export const ATUALIZAR_HORARIO_PERMITIDO = gql`
  mutation AtualizarHorarioPermitido($id: ID!, $input: HorarioPermitidoInput!) {
    atualizarHorarioPermitido(id: $id, input: $input) {
      id diaSemana horaInicio horaFim
    }
  }
`;

export const DELETAR_HORARIO_PERMITIDO = gql`
  mutation DeletarHorarioPermitido($id: ID!) {
    deletarHorarioPermitido(id: $id)
  }
`;

export const DELETAR_TODOS_HORARIOS = gql`
  mutation DeletarTodosHorariosPermitidos($quadraId: ID!) {
    deletarTodosHorariosPermitidos(quadraId: $quadraId)
  }
`;

// ── Preços ────────────────────────────────────────────────────────────────────

export const CRIAR_PRECO_QUADRA = gql`
  mutation CriarPrecoQuadra($quadraId: ID!, $input: PrecoQuadraInput!) {
    criarPrecoQuadra(quadraId: $quadraId, input: $input) {
      id diaSemana horaInicio horaFim valorPorHora
    }
  }
`;

export const DELETAR_PRECO_QUADRA = gql`
  mutation DeletarPrecoQuadra($id: ID!) {
    deletarPrecoQuadra(id: $id)
  }
`;

export const DELETAR_TODOS_PRECOS = gql`
  mutation DeletarTodosPrecosQuadra($quadraId: ID!) {
    deletarTodosPrecosQuadra(quadraId: $quadraId)
  }
`;

// ── Agendamentos Admin ────────────────────────────────────────────────────────

export const AGENDAMENTOS_POR_QUADRA_E_DATA = gql`
  query AgendamentosPorQuadraEData($quadraId: ID!, $data: String!) {
    agendamentosPorQuadraEData(quadraId: $quadraId, data: $data) {
      id
      dataAgendamento
      horaInicio
      horaFim
      status
      valor
      observacao
      reservaExpiraEm
      criadoEm
      usuario { id nome email atleta { telefone } }
    }
  }
`;

export const CRIAR_AGENDAMENTO_ADMIN = gql`
  mutation CriarAgendamentoAdmin($input: AgendamentoInput!) {
    criarAgendamentoAdmin(input: $input) {
      id status valor observacao
    }
  }
`;

export const EDITAR_AGENDAMENTO = gql`
  mutation EditarAgendamento($id: ID!, $input: AgendamentoInput!) {
    editarAgendamento(id: $id, input: $input) {
      id dataAgendamento horaInicio horaFim valor
    }
  }
`;

export const CANCELAR_AGENDAMENTO_ADMIN = gql`
  mutation CancelarAgendamento($id: ID!, $motivo: String) {
    cancelarAgendamento(id: $id, motivo: $motivo) {
      agendamento { id status motivoCancelamento }
      multaAplicada
    }
  }
`;

export const CONFIRMAR_PAGAMENTO_ADMIN = gql`
  mutation ConfirmarPagamentoAdmin($id: ID!, $valorPago: Float) {
    confirmarPagamentoAdmin(id: $id, valorPago: $valorPago) { id status valor }
  }
`;

// ── Bloqueios ─────────────────────────────────────────────────────────────────

export const CRIAR_BLOQUEIO = gql`
  mutation CriarBloqueioAgenda($input: BloqueioAgendaInput!) {
    criarBloqueioAgenda(input: $input) {
      bloqueio { id dataBloqueio horaInicio horaFim motivo temConflitos }
      conflitos { id horaInicio horaFim status }
    }
  }
`;

export const DELETAR_BLOQUEIO = gql`
  mutation DeletarBloqueioAgenda($id: ID!) {
    deletarBloqueioAgenda(id: $id)
  }
`;

export const BLOQUEIOS_POR_QUADRA_E_DATA = gql`
  query BloqueiosPorQuadraEData($quadraId: ID!, $data: String!) {
    bloqueiosPorQuadraEData(quadraId: $quadraId, data: $data) {
      id
      horaInicio
      horaFim
      motivo
      temConflitos
      criadoEm
    }
  }
`;

// ── Usuários ─────────────────────────────────────────────────────────────────

export const BUSCAR_USUARIOS = gql`
  query BuscarUsuarios($nome: String!) {
    usuariosPorNome(nome: $nome) {
      id
      nome
      email
    }
  }
`;

// ── Relatório ─────────────────────────────────────────────────────────────────

export const RELATORIO_AGENDAMENTOS = gql`
  query RelatorioAgendamentos($quadraId: ID!, $inicio: String!, $fim: String!) {
    relatorioAgendamentos(quadraId: $quadraId, inicio: $inicio, fim: $fim) {
      total
      porStatus
      totalPago
      totalPendente
      totalCancelados
    }
  }
`;

// Relatório agregado de TODAS as quadras de um local no período.
export const RELATORIO_AGENDAMENTOS_LOCAL = gql`
  query RelatorioAgendamentosLocal($localId: ID!, $inicio: String!, $fim: String!) {
    relatorioAgendamentosLocal(localId: $localId, inicio: $inicio, fim: $fim) {
      total
      porStatus
      totalPago
      totalPendente
      totalCancelados
    }
  }
`;

// Relatório agregado de um conjunto específico de quadras (multi-seleção) no período.
export const RELATORIO_AGENDAMENTOS_QUADRAS = gql`
  query RelatorioAgendamentosQuadras($quadraIds: [ID!]!, $inicio: String!, $fim: String!) {
    relatorioAgendamentosQuadras(quadraIds: $quadraIds, inicio: $inicio, fim: $fim) {
      total
      porStatus
      totalPago
      totalPendente
      totalCancelados
    }
  }
`;

// ── Helpers ───────────────────────────────────────────────────────────────────

export const DIAS_SEMANA = [
  { value: 'SEGUNDA', label: 'Segunda' },
  { value: 'TERCA', label: 'Terça' },
  { value: 'QUARTA', label: 'Quarta' },
  { value: 'QUINTA', label: 'Quinta' },
  { value: 'SEXTA', label: 'Sexta' },
  { value: 'SABADO', label: 'Sábado' },
  { value: 'DOMINGO', label: 'Domingo' },
];

export const gerarHorarios = (duracaoSlotMinutos: number = 30) => {
  const slots: string[] = [];
  for (let h = 0; h < 24; h++) {
    for (let m = 0; m < 60; m += duracaoSlotMinutos) {
      slots.push(`${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`);
    }
  }
  return slots;
};

export const BLOQUEIOS_POR_LOCAL_E_DATA = gql`
  query BloqueiosPorLocalEData($localId: ID!, $data: String!) {
    bloqueiosPorLocalEData(localId: $localId, data: $data) {
      quadra { id nome }
      bloqueios { id horaInicio horaFim motivo }
    }
  }
`;

export const BLOQUEIOS_DIAS_DO_MES = gql`
  query BloqueiosDiasDoMes($localId: ID!, $mes: Int!, $ano: Int!) {
    bloqueiosDiasDoMes(localId: $localId, mes: $mes, ano: $ano)
  }
`;

export const CONFIGURACAO_CANCELAMENTO = gql`
  query ConfiguracaoCancelamento($localId: ID!) {
    configuracaoCancelamento(localId: $localId)
  }
`;

export const SALVAR_CONFIGURACAO_CANCELAMENTO = gql`
  mutation SalvarConfiguracaoCancelamento($localId: ID!, $janelaHorasReembolso: Int!) {
    salvarConfiguracaoCancelamento(localId: $localId, janelaHorasReembolso: $janelaHorasReembolso) {
      id
      nome
      janelaHorasReembolso
    }
  }
`;

export const REMOVER_CONFIGURACAO_CANCELAMENTO = gql`
  mutation RemoverConfiguracaoCancelamento($localId: ID!) {
    removerConfiguracaoCancelamento(localId: $localId)
  }
`;
